import { getType } from 'typesafe-actions';
import { getCdsCurves,
         getBanks,
         createBank,
         updateBank,
         getBankEntities,
         getClientBankAccounts,
         getCounterpartyBanks,
         getCreditRatings,
         getCsaThresholds,
         createCsaThreshold,
         updateCsaThreshold,
         deleteCsaThreshold,

        } from './actions';


import { Bank,
         BankEntity,
         CdsCurve,
         ClientBankAccount,
         CounterpartyBankAccount,
         CreditRatings,
         CsaThreshold,

        } from '../types';


export interface BanksState {
  data: Bank[];
  loading: boolean;
  bankEntities: {
    data: BankEntity[];
    loading: boolean;
  };
  cdsCurves: {
    data: CdsCurve[];
    loading: boolean;
  };
   clientBankAccounts: {
    data: ClientBankAccount[];
    loading: boolean;
  };
  counterpartyBankAccounts: {
    data: CounterpartyBankAccount[];
    loading: boolean;
  };
   creditRatings: {
    data: CreditRatings;
    loading: boolean;
  };
  csaThresholds: {
    data: CsaThreshold[];
    loading: boolean;
  };
}

const initialState: BanksState = {
  data: [],
  loading: false,
  bankEntities: {
    data: [],
    loading: false,
  },
  cdsCurves: {
    data: [],
    loading: false,
  },
  clientBankAccounts: {
    data: [],
    loading: false,
  },
  counterpartyBankAccounts: {
    data: [],
    loading: false,
  },
  creditRatings: {
  data: { s_p: [], moody: [], fitch: [] },
  loading: false,
},
  csaThresholds: {
    data: [],
    loading: false,
  },

};

export const banksReducer = (state = initialState, action: any): BanksState => {
  switch (action.type) {
    // -----------------
    // Banks
    // -----------------
    case getType(getBanks.request):
    case getType(createBank.request):
    case getType(updateBank.request):
      return {
        ...state,
        loading: true,
      };

    case getType(getBanks.success):
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };

    case getType(createBank.success):
      return {
        ...state,
        loading: false,
        data: [...state.data, action.payload.data],
      };

    case getType(updateBank.success):
      return {
        ...state,
        loading: false,
        data: state.data.map((bank) =>
          bank.bank_id === action.payload.data.id ? action.payload.data : bank
        ),
      };

    case getType(getBanks.failure):
    case getType(createBank.failure):
    case getType(updateBank.failure):
      return {
        ...state,
        loading: false,
      };

    // -----------------
    // Bank Entities
    // -----------------
    case getType(getBankEntities.request):
      return {
        ...state,
        bankEntities: {
          ...state.bankEntities,
          loading: true,
        },
      };

    case getType(getBankEntities.success):
      return {
        ...state,
        bankEntities: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(getBankEntities.failure):
      return {
        ...state,
        bankEntities: {
          ...state.bankEntities,
          loading: false,
        },
      };

    // -----------------
    // CDS Curves
    // -----------------
    case getType(getCdsCurves.request):
      return {
        ...state,
        cdsCurves: {
          ...state.cdsCurves,
          loading: true,
        },
      };

    case getType(getCdsCurves.success):
      return {
        ...state,
        cdsCurves: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(getCdsCurves.failure):
      return {
        ...state,
        cdsCurves: {
          ...state.cdsCurves,
          loading: false,
        },
      };

    // -----------------
    // Cleint Banks
    // -----------------

    case getType(getClientBankAccounts.request):
      return {
        ...state,
        clientBankAccounts: {
          ...state.clientBankAccounts,
          loading: true,
        },
      };

    case getType(getClientBankAccounts.success):
      return {
        ...state,
        clientBankAccounts: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(getClientBankAccounts.failure):
      return {
        ...state,
        clientBankAccounts: {
          ...state.clientBankAccounts,
          loading: false,
        },
      };

    // -----------------
    // Counterparty Banks
    // -----------------
    case getType(getCounterpartyBanks.request):
      return {
        ...state,
        counterpartyBankAccounts: {
          ...state.counterpartyBankAccounts,
          loading: true,
        },
      };

    case getType(getCounterpartyBanks.success):
      return {
        ...state,
        counterpartyBankAccounts: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(getCounterpartyBanks.failure):
      return {
        ...state,
        counterpartyBankAccounts: {
          ...state.counterpartyBankAccounts,
          loading: false,
        },
      };

      // -----------------
      // Credit Ratings
      // -----------------
      case getType(getCreditRatings.request):
        return {
          ...state,
          creditRatings: {
            ...state.creditRatings,
            loading: true,
          },
        };

      case getType(getCreditRatings.success):
        return {
          ...state,
          creditRatings: {
            data: action.payload.data,
            loading: false,
          },
        };

      case getType(getCreditRatings.failure):
        return {
          ...state,
          creditRatings: {
            ...state.creditRatings,
            loading: false,
          },
        };

    // -----------------
    // CSA Thresholds
    // -----------------
    case getType(getCsaThresholds.request):
    case getType(createCsaThreshold.request):
    case getType(updateCsaThreshold.request):
    case getType(deleteCsaThreshold.request):
      return {
        ...state,
        csaThresholds: {
          ...state.csaThresholds,
          loading: true,
        },
      };

    case getType(getCsaThresholds.success):
      return {
        ...state,
        csaThresholds: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(createCsaThreshold.success):
      return {
        ...state,
        csaThresholds: {
          data: [...state.csaThresholds.data, action.payload.data],
          loading: false,
        },
      };

    case getType(updateCsaThreshold.success):
      return {
        ...state,
        csaThresholds: {
          data: state.csaThresholds.data.map((threshold) =>
            threshold.id === action.payload.data.id
              ? action.payload.data
              : threshold
          ),
          loading: false,
        },
      };

    case getType(deleteCsaThreshold.success):
      return {
        ...state,
        csaThresholds: {
          data: state.csaThresholds.data.filter(
            (threshold) => threshold.id !== action.payload.id
          ),
          loading: false,
        },
      };

    case getType(getCsaThresholds.failure):
    case getType(createCsaThreshold.failure):
    case getType(updateCsaThreshold.failure):
    case getType(deleteCsaThreshold.failure):
      return {
        ...state,
        csaThresholds: {
          ...state.csaThresholds,
          loading: false,
        },
      };

    default:
      return state;
  }
};
